<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12">
    <h2 class="page-title">{{ 'alert.active_alerts' | translate }}</h2>
    <div class="col-12 mb-2 p-0">
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">
                    {{ 'breadcrumb.' + breadcrumb | translate }}
                </span>  
            </ng-container>
        </xng-breadcrumb>
    </div>
    <div class="row">
        <div class="col-xl-8 col-lg-12 alert-map">
            <agm-map #AgmMap [usePanning]="true" [zoom]="zoom" [latitude]="lat" [longitude]="lng" [mapTypeControl]='true' [mapTypeId]="'roadmap'" (mapClick)="close_window()" (mapReady)="mapReady($event)" fullscreenControl="true"  aria-kbdshortcuts="false" keyboardShortcuts="false">
                <ng-container *ngFor="let d of alertService.alerts; trackBy: identify; let index=index; let last=last;">
                    <agm-marker *ngIf="d.initialLatitude && d.initialLongitude" [id]="d.id" [latitude]="+d.initialLatitude" [longitude]="+d.initialLongitude" iconUrl="#">
                        <agm-overlay [latitude]="+d.initialLatitude" [longitude]="+d.initialLongitude">
                            <i class="fas fa-map-marker-alt h2" style.color="{{d.alertTypeColor}}"></i>
                        </agm-overlay>
                        <agm-info-window #infoWindow class="infoWindow bg-white">
                            <div class="row m-0 bg-white">
                                <div class="col-2 p-0">
                                    <img class="img-round" [src]="d.userPhoto ? d.userPhoto : 'assets/images/default-user.jpeg'" width="60" height="60" title="{{d.createdByName}}" alt="{{d.createdByName}}">
                                </div>
                                <div class="col-8">
                                    <div *ngIf="d.inGeofence==0"><strong><span class="btn-orange">{{'alert.out-of-zone' | translate}}</span></strong></div>
                                    <div><strong>{{ 'general.alert' | translate }} #{{ d.id }}</strong></div>
                                    <div><strong>{{ alertDate.convertUTCDateToLocalDate(d.createdDate) }}</strong></div>
                                    <div><strong>{{ d.createdByName }}</strong></div>
                                    <div><strong>{{ 'alert.latitude' | translate }}: {{ d.initialLatitude }}</strong></div>
                                    <div><strong>{{ 'alert.longitude' | translate }}: {{ d.initialLongitude }}</strong></div>
                                    <div><strong>{{ (d.status==0?'alert.unattended':((d.status==3||d.status==4)?'alert.canceled':'alert.attending')) | translate }}</strong></div>
                                </div>
                                <div class="col-2 text-left p-0 mt-2"><span class="btn cursor" title="" [routerLink]="['view-alert',alertService.alerts[index].id]" routerLinkActive="active"><i class="fa fa-eye h2" title="{{'alert.view_details' | translate}}"></i></span></div>
                            </div>
                        </agm-info-window>
                    </agm-marker>
                </ng-container>
            </agm-map>
        </div>
        <div class="col-xl-4 col-lg-12">
            <div class="card card-height" style="border-radius: 12px;">
                <div class="card-header" style="border-radius: 12px 12px 0px 0px;">
                    <div class="row">
                        <div class="col-6">
                            <h5>{{ 'alert.open_alerts' | translate }} {{alertService?.alerts && alertService.totalLength?"("+alertService?.totalLength+")":""}}</h5>
                        </div>
                        <div ngbDropdown placement="bottom-right" [autoClose]="'outside'" class="col-6"> 
                            <button tabindex="0" class="btn-filter float-right" title="" (click)="getDispatchGeo()" ngbDropdownToggle>
                                <i class="fas fa-sliders-h alertia-primary-color" title="{{ 'alert.filter' | translate }}" aria-hidden="true"></i>
                                <span *ngIf="alertService.filtersApplied && alertService.filtersApplied.length > 0" class="badge badge-pill float-right badge-dark ml-1">{{alertService.filtersApplied.length}}</span>
                            </button>
                            <button tabindex="0" class="btn-filter float-right" title="" (click)="changeOrder()">
                                <i [class]="alertService.selectedOrder === 'Descending'? 'fas fa-long-arrow-alt-down alertia-primary-color':'fas fa-long-arrow-alt-up alertia-primary-color'" title="{{ (alertService.selectedOrder === 'Descending'? 'descending_order':'ascending_order') | translate }}" aria-hidden="true"></i>
                            </button>
                        <div class="mw-3" ngbDropdownMenu>
                        <div class="modal-header" data-backdrop="false">
                            <h4 class="center">{{ 'alert.filter' | translate }}</h4>
                            <button tabindex="0" type="button" title="{{ 'general.close_window' | translate }}" class="btn-close ml-2" id="close" ngbDropdownToggle>&times;</button>
                        </div>
                        <div class="modal-body">
                        <span class="ml-2">{{'general.agent' | translate}}</span><br>
                        <div ngbDropdown class="text-center">
                            <button class="btn btn-outline-secondary bg-white text-dark mh-30 w-100 dd-size text-center"
                                    title="{{ alertService.agentFilter | translate }}" ngbDropdownToggle>
                                    {{ alertService.agentFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu class="dd-size">
                                <button ngbDropdownItem (click)="changeAgentFilterLabel('general.select_agent', 0)" title="{{ 'general.select_agent' | translate }}" *ngIf="alertService.agentFilter!='general.select_agent'">
                                    {{ 'general.select_agent' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeAgentFilterLabel(agent.profileFullName, agent.id)" title="{{ agent.profileFullName }}" *ngFor="let agent of alertService.agents">
                                    {{ agent.profileFullName.length > 30? (agent.profileFullName | slice:0:27) + '...' : agent.profileFullName }}
                                </button>
                            </div>
                        </div>
                        <span class="ml-2">{{'alert.alert_type' | translate}}</span><br>
                        <div ngbDropdown class="text-center">
                            <button [disabled] = "alertService.alertTypeDisabled" class="btn btn-outline-secondary bg-white text-dark mh-30 w-100 dd-size text-center"
                                    title="{{ alertService.alertTypeFilter | translate }}" ngbDropdownToggle>
                                    {{ alertService.alertTypeFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu class="dd-size">
                                <button ngbDropdownItem (click)="changeAlertFilterLabel('select_alert_type')" title="{{ 'select_alert_type' | translate }}" *ngIf="alertService.alertTypeFilter!='select_alert_type'">
                                    {{ 'select_alert_type' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeAlertFilterLabel(typeOfAlert.name)" title="{{ typeOfAlert.name }}" *ngFor="let typeOfAlert of alertService.alertTypes">
                                    {{ typeOfAlert.name.length > 30? (typeOfAlert.name | slice:0:27) + '...' : typeOfAlert.name }}
                                </button>
                            </div>
                        </div>
                        <span class="ml-2">{{'alert.status' | translate}}</span><br>
                        <div ngbDropdown class="text-center">
                            <button class="btn btn-outline-secondary bg-white text-dark mh-30 w-100 dd-size"
                                    title="{{ alertService.statusToDisplay | translate }}" ngbDropdownToggle>
                                    {{ alertService.statusToDisplay | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button ngbDropdownItem (click)="changeStatusFilterLabel('alert.select_status')" title="{{ 'alert.select_status' | translate }}" *ngIf="alertService.statusToDisplay!='alert.select_status'">
                                    {{ 'alert.select_status' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeStatusFilterLabel('alert.' + status.toLowerCase())" title="{{ 'alert.' + status.toLowerCase() | translate }}" *ngFor="let status of statusTypes">
                                    {{ 'alert.' + status.toLowerCase() | translate }}
                                </button>
                            </div>
                        </div>
                        <div *ngIf = "geoZoneAssignment">
                            <span class="ml-2">{{'alert.geo_zone' | translate}}</span><br>
                            <div ngbDropdown class="text-center">
                                <button class="btn btn-outline-secondary bg-white text-dark mh-30 w-100 dd-size"
                                        title="{{ alertService.zoneFilter | translate }}" ngbDropdownToggle>
                                        {{ alertService.zoneFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </button>
                                <div ngbDropdownMenu>
                                    <button ngbDropdownItem (click)="changeZoneFilterLabel('alert.select_geo_zone', 0)" title="{{ 'alert.select_geo_zone' | translate }}" *ngIf="alertService.zoneFilter!='alert.select_geo_zone'">
                                        {{ 'alert.select_geo_zone' | translate }}
                                    </button>
                                    <button ngbDropdownItem (click)="changeZoneFilterLabel(zones.name, zones.id)" title="{{ zones.name }}" *ngFor="let zones of alertService.alertZones">
                                        {{ zones.name }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <span class="ml-2">{{ 'alert.out_of_zone' | translate }}</span><br>
                        <div ngbDropdown class="text-center">
                            <button class="btn btn-outline-secondary bg-white text-dark mh-30 w-100 dd-size" title="{{ alertService.outZoneFilter | translate }}" ngbDropdownToggle>
                                {{ alertService.outZoneFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button ngbDropdownItem (click)="changeOutZoneFilterLabel('alert.select-out-of-zone')" title="{{ 'alert.select-out-of-zone' | translate }}" *ngIf="alertService.outZoneFilter!='alert.select-out-of-zone'">
                                    {{ 'alert.select-out-of-zone' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeOutZoneFilterLabel('alert.out_of_zone')" title="{{ 'alert.out_of_zone' | translate }}">
                                    {{ 'alert.out_of_zone' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeOutZoneFilterLabel('alert.not-out-of-zone')" title="{{ 'alert.not-out-of-zone' | translate }}">
                                    {{ 'alert.not-out-of-zone' | translate }}
                                </button>
                            </div>
                        </div>
                        <span class="ml-2">{{ 'alert.late' | translate }}</span><br>
                        <div ngbDropdown class="text-center">
                            <button class="btn btn-outline-secondary bg-white text-dark mh-30 w-100 dd-size" title="{{ alertService.lateFilter | translate }}" ngbDropdownToggle>
                                {{ alertService.lateFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <button ngbDropdownItem (click)="changeLateZoneFilterLabel('alert.select-late')" title="{{ 'alert.select-late' | translate }}" *ngIf="alertService.lateFilter!='alert.select-late'">
                                    {{ 'alert.select-late' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeLateZoneFilterLabel('alert.late')" title="{{ 'alert.late' | translate }}">
                                    {{ 'alert.late' | translate }}
                                </button>
                                <button ngbDropdownItem (click)="changeLateZoneFilterLabel('alert.not-late')" title="{{ 'alert.not-late' | translate }}">
                                    {{ 'alert.not-late' | translate }}
                                </button>
                            </div>
                        </div>
                        </div>
                        <div class="modal-footer center">
                            <span class="col-6 input-group-addon">
                                <button tabindex="0" class="btn btn-red btn-h-red w-100" title="{{ 'alert.clear_filter' | translate }}" (click)="clearFilter()" ngbDropdownToggle>
                                    {{ 'alert.clear_filter' | translate }}
                                </button>
                            </span>
                            <span class="col-6 input-group-addon">
                                <button tabindex="0" class="btn btn-green btn-h-green w-100" title="{{ 'general.apply_filter' | translate }}" (click)="applyFilter()" ngbDropdownToggle>
                                    {{ 'general.apply_filter' | translate }}
                                </button>
                            </span>
                        </div>
                     </div> 
                    </div>  
                    </div>
                    <div class="row" *ngIf="alertService.filtersApplied">
                        <div class="col-12">
                             <span class="badge badge-pill badge-light" *ngFor="let filters of alertService.filtersApplied">
                                <span title= "{{ filters | translate }}"> {{ filters.length > 30? (filters | slice:0:27) + '...' : filters | translate}} </span> <button type="button" class="btn-filter" (click)="removeFilter(filters)">&times;</button>
                            </span>
                        </div>
                    </div>
                </div>
                <ul class="list-group list-group-flush oy">
                    <ng-container *ngFor="let d of alertService.alerts; trackBy: identify; let index=index; let odd=odd; let even=even;">
                        <li class="list-group-item">
                            <div class="row">
                                <div class="col-2 m-auto user-img text-center pl-1">
                                    <img class="img-icon" [style.borderColor]="d.alertTypeColor" [src]="d.userPhoto ? d.userPhoto : 'assets/images/default-user.jpeg'" width="65" height="65" title="{{d.createdByName}}" alt="{{d.createdByName}}">
                                </div>
                                <div class="col-10">
                                    <div class="row">
                                        <div *ngIf="d.inGeofence==0"class="col-7 p-0 pb-1">
                                            <strong><span class="btn-orange p-1">{{'alert.out-of-zone' | translate}}</span></strong>
                                        </div>
                                        <div *ngIf="((((lateTimer > d.attendMilliseconds && d.attendMilliseconds && (d.status != 2 && d.status != 4)) || 
                                            (lateTimer > d.closeMilliseconds && d.closeMilliseconds) || (lateTimer > d.closeMilliseconds && 
                                            d.closeMilliseconds > d.attendMilliseconds && (d.attendMilliseconds && 
                                            d.closeMilliseconds)) || (d.late && d.late == 'True')) && d.status != 3) || (verifyUnattendedLate(d) && d.attendMilliseconds))" class="col-5 p-0 pb-1">
                                            <strong><span class="btn-orange p-1">{{'alert.late_tag' | translate}}</span></strong>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <strong>
                                                {{ d.createdByName }}
                                            </strong>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            {{ 'alert_type' | translate }}:
                                        </div>
                                        <div class="col-6">
                                            <strong> <!-- [style.color]="d.alertTypeColor" -->
                                                {{ d.alertTypeName }}
                                            </strong>
                                        </div>            
                                    </div>           
                                    <div class="row">
                                        <div class="col-6">      
                                            {{ 'alert.alert_id' | translate }}
                                        </div>
                                        <div class="col-6">  
                                            # {{ d.id }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6"> 
                                            {{ 'general.status' | translate }}
                                        </div>
                                        <div class="col-6">
                                            <strong>
                                                {{ (d.status==6?'alert.dispatch_process':(d.status==0||d.status==7)?'alert.unattended':((d.status==3||d.status==4)?'alert.canceled':'alert.attending')) | translate }}
                                            </strong>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="d.attendedByName && (d.status==2||d.status==4)">
                                        <div class="col-6">
                                            {{ 'roles.sec_agent' | translate}}:
                                        </div>
                                        <div class="col-6">
                                            {{ d.attendedByName }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            {{ 'alert.alarm_received' | translate }}
                                        </div>
                                        <div class="col-6">
                                            {{ alertDate.convertUTCDateToLocalDate(d.createdDate) }}
                                        </div>
                                    </div>
                                    <div class="row" *ngIf = "d.userGroups">
                                        <div class="col-6">
                                            {{ 'alert.user_groups' | translate }}
                                        </div>
                                        <div class="col-6">
                                            {{ d.userGroups }}
                                        </div>
                                    </div>
                                    <!-- <div class="col-12 p-0">
                                        {{ 'alert.alarm_received' | translate }}{{ alertDate.convertUTCDateToLocalDate(d.createdDate) }}
                                    </div>
                                    <div *ngIf = "d.userGroups" class="col-12 p-0 text-break">
                                        {{ 'alert.user_groups' | translate }}{{ d.userGroups }}
                                    </div> -->
                                </div>
                                <div class="col-12 text-center pt-2" style="max-width: 27em;">
                                    <button *ngIf= "alertService.alerts[index].initialLatitude && alertService.alerts[index].initialLongitude" class="btn btn-red btn-h-red btn-sm" title="{{ 'alert.view_on_map' | translate }}" type="submit" (click)="recenter_map(alertService.alerts[index].initialLatitude,alertService.alerts[index].initialLongitude)">
                                        <span>
                                            <i class="fa fa-map-marker fa-sm pr-1"></i>
                                                {{ 'alert.location' | translate }}
                                        </span>
                                    </button>
                                    <!--(click)="viewAlert(alertService.alerts[index])"-->
                                    <button class="btn btn-alertia btn-blue btn-h-blue btn-sm ml-2" title="{{ 'alert.view_details' | translate }}" [routerLink]="['view-alert',alertService.alerts[index].id]" routerLinkActive="active">
                                        <span>
                                            <i class="fa fa-eye fa-sm pr-1"></i>
                                            {{ 'alert.view_details' | translate }}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ng-container>
                </ul>
                <div class="col-12">        
                    <mat-paginator #paginator [pageIndex]="alertService.page" [length]="alertService.totalLength" [pageSizeOptions]="[50]" showFirstLastButtons (page)="nextPage($event)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
